// @flow
import $ from 'jquery';
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import {
  addCommas,
  trimCommas,
  removeNonNumeric,
} from '../../../utils/commonUtils';
import dayjs from 'dayjs';

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.initDateRangePicker(this.$el);
    this.initFormatValue();
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        locale: {
          format: 'Y年MM月DD日',
        },
      },
      {
        picker: {
          format: {
            start: 'Y年MM月DD日',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  // 入力値の表示変換処理
  initFormatValue = () => {
    const $amount = $('#company_funding_round_target_amount');
    const $deadlineAt = $('#company_funding_round_target_deadline_at');
    $amount.val(addCommas(removeNonNumeric($amount.val())));
    if ($deadlineAt.val()) {
      $deadlineAt.val(dayjs($deadlineAt.val()).format('Y年MM月DD日'));
    }
  };

  // 送信時に入力値のフォーマットを元に戻す処理
  unformatValue = () => {
    const $amount = $('#company_funding_round_target_amount');
    const $deadlineAt = $('#company_funding_round_target_deadline_at');
    $amount.val(trimCommas($amount.val()));
    $deadlineAt.val(
      $deadlineAt
        .val()
        .replace(/[年|月]/g, '-')
        .replace(/[日]/g, ''),
    );
  };

  onSubmit() {
    this.unformatValue();
    return true;
  }

  @on({ event: 'click', selector: '#submit' })
  onClickSubmit() {
    this.onSubmit();
  }

  removeNonDigitFromTargetAmount(event: any) {
    const input = $(event.target);
    let targetAmount = input.val();
    targetAmount = targetAmount.replace(/\D/g, '');
    input.val(addCommas(targetAmount));
  }

  @on({ event: 'change', selector: '#company_funding_round_target_amount' })
  onChangeTargetAmount(event: any) {
    this.removeNonDigitFromTargetAmount(event);
  }

  @on({
    event: 'input',
    selector: '#company_funding_round_target_amount',
  })
  onInputTargetAmount(event: any) {
    this.removeNonDigitFromTargetAmount(event);
  }

  @on({
    event: 'keydown',
    selector: '#company_funding_round_target_deadline_at',
  })
  onDeleteTargetDeadlineAt(event: any) {
    // deleteかbackspaceが入力されたら日付フィールドを空にする
    if (event.key.match(/Delete|Backspace/g)) {
      $(event.target).val('');
    }
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur input', selector: '.form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  @on({ event: 'click' })
  onClickOtherArea(event: any) {
    if (!$(event.target).closest('.date-field').length) {
      $('.date-field').removeClass('focus');

      if ($('.date-field').val().length === 0) {
        $('.date-field').removeClass('form-control-active');
      }
    }
  }
}
